<app-confirmation-modal
  [title]="data.title"
  (cancel)="cancel()"
  (confirm)="confirm()"
>
  <p [innerHtml]="data.content"></p>
</app-confirmation-modal>
